/** One finding, and the glyph a verdict wears (moved out of `Reports.tsx` unchanged). */

import type { Finding } from "../api/queries";
import { VERDICT_ICON } from "./verdictWords";
import own from "./Reports.module.css";
import { cls } from "./reportsFormat";
import { customerText } from "../lib/customerWords";

/** One rule the report did not pass. Blocking and advisory must not look alike.
 *
 * One has to be fixed before a filing and the other has to be read — 20H excepts the first year,
 * so a first-year company with no prior-year figures is advised and not stopped. A screen that
 * rendered both the same way would teach people to skim both.
 */
export function FindingRow({ finding }: { finding: Finding }) {
  return (
    <div className={cls(own.finding)} data-testid="finding" data-severity={finding.severity}>
      <span className={cls(own.sev, finding.severity === "advisory" && own.sevAdvisory)}>
        {finding.severity === "advisory" ? "Advisory" : "Blocking"}
      </span>
      <span className={cls(own.findingBody)}>
        <strong className={cls(own.findingMessage)} data-testid="finding-message">
          {finding.message}
        </strong>
        <span className={cls(own.detail)}>{finding.detail}</span>
        <span className={cls(own.remedy)}>{finding.remedy}</span>
        <span className={cls(own.cite)} data-testid="finding-citation">
          {finding.source_url ? (
            <a href={finding.source_url} target="_blank" rel="noreferrer">
              {customerText(finding.citation)}
            </a>
          ) : (
            customerText(finding.citation)
          )}
        </span>
      </span>
    </div>
  );
}

export function VerdictGlyph({ verdict }: { verdict: string }) {
  const Glyph = VERDICT_ICON[verdict];
  if (!Glyph) return null;
  return (
    <Glyph
      className={cls(own.verdictGlyph)}
      size={18}
      weight={verdict === "issued" ? "fill" : "regular"}
      aria-hidden="true"
    />
  );
}

